import styled from "@emotion/styled";
import { NAV_LINKS } from "config/consts";
import { useIsMobile } from "hooks/useDeviceType";
import { GlobalStore } from "store/global/GlobalStore";
import MediumIconRaw from "../../../img/about/medium-small.svg?react";
import DiscordIconRaw from "../../../img/discord.svg?react";
import TwitterIconRaw from "../../../img/twitter.svg?react";

export const Socials = () => {
  const theme = GlobalStore.useState(s => s.theme);
  const isMobile = useIsMobile();
  const iconSize = 24;

  const Wrapper = isMobile ? LinksWrapperMobile : LinksWrapper;

  return (
    <Wrapper>
      <SocialLink href={NAV_LINKS.DISCORD} target="_blank" rel="noreferrer">
        <DiscordIcon color={theme.theme[800]} width={iconSize} height={iconSize} />
      </SocialLink>
      <SocialLink href={NAV_LINKS.TWITTER} target="_blank" rel="noreferrer">
        <TwitterIcon color={theme.theme[800]} width={iconSize} height={iconSize} />
      </SocialLink>
      <SocialLink href={NAV_LINKS.MEDIUM} target="_blank" rel="noreferrer">
        <MediumIcon color={theme.theme[800]} width={iconSize} height={iconSize} />
      </SocialLink>
    </Wrapper>
  );
};

// Sub-components

const LinksWrapper = styled.div`
  display: flex;
  gap: 13px;
  padding: 11px 15px;
  background-color: ${props => props.theme.surface.alt.secondary.default};
  border-radius: 24px;
`;

const LinksWrapperMobile = styled.div`
  z-index: 1000;
  display: flex;
  flex-direction: column;
  width: fit-content;
  border-radius: 24px;
  gap: 10px;
  padding: 10px;
  background-color: ${props => props.theme.surface.alt.secondary.default};
  margin-bottom: 16px;
`;

const DiscordIcon = styled(DiscordIconRaw)`
  transition: color 0.2s linear;
  &:hover {
    color: ${props => props.theme.theme[1000]};
  }
`;

const TwitterIcon = styled(TwitterIconRaw)`
  transition: color 0.2s linear;
  &:hover {
    color: ${props => props.theme.theme[1000]};
  }
`;

const MediumIcon = styled(MediumIconRaw)`
  transition: color 0.2s linear;
  &:hover {
    color: ${props => props.theme.theme[1000]};
  }
`;

const SocialLink = styled.a`
  display: flex;
  align-items: center;
`;
